export const CLOUDCHAT_SUPPORT_SLOT_ATTRIBUTE = 'data-cloudchat-support-slot';

export const canShowCloudchatSupportWidget = ({ accountId } = {}) =>
  Boolean(accountId);
